import React, { useCallback } from 'react'
import { Modal, Toast } from 'antd-mobile'
import style from './oderInfothree.module.css'
import { useEffect, useState, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import Login from '../loginthree'
import { goodsauthtwo, getNewKey } from '../../utils/toolthree'
import Detainment from '../Detainment/indexthree'
import DetainmentPay from './Mypopupthreeplay'
import { PAY } from '../../utils/config'
import jquery from 'jquery';
import {addGatherRes} from '../../utils/setApi'

export default function Mypopup(poprs) {
    let history = useLocation()
    const [countDown, setCountDown] = useState(1800)
    let [checked, setChecked] = useState(false) // 协议选择
    let [key, setKey] = useState(undefined) // 用户key
    let [member_id, setMember_id] = useState(undefined) // 用户id
    let [phoneNum, setPhoneNum] = useState(false) //是否登录过
    let [userPhone, setUserPhone] = useState('') //用户手机号
    // let [userPhones, setUserPhones] = useState('') //用户手机号1
    let [goodsPrice, setGoodsPrice] = useState('')
    const [checkedPay, setCheckedPay] = useState(() => PAY.WX) // 支付选择
    const [modal2, setModal2] = useState(false)
    const [modal3, setModal3] = useState(false)
    const [subFlag, setSubFlag] = useState(false)
    // console.log(poprs.timeData)
    let [sum, setSum] = useState('98');
    const resid = useRef()
    const resTp = useRef("edp")
    /**
     * 判断是否登录过，没登录获取用户信息，登录过直接调取支付
     */
    function getPhone() {
        return sessionStorage.getItem('member_id') ? true : false
    }
    // 存储用户信息
    function storagUsertUserInfo(info) {
        sessionStorage.setItem(info.name, info.value)
    }
    // 获取用户信息
    function getUserInfo(name) {
        return sessionStorage.getItem(name) || localStorage.getItem(name)
    }

    useEffect(() => {
        setGoodsPrice(() => (poprs.sku_id == 1 ? '8.8' : '8.8'))
    }, [poprs.sku_id, goodsPrice])

    useEffect(() => {
        setTimeout(() => {
            burying()
        })
    }, [])
    //名额倒计时
    useEffect(() => {
        sessionStorage.removeItem('sumNber');
        if(!sessionStorage.getItem('sumNber')){
            sessionStorage.setItem('sumNber',98)
        }
        let tiemId = setInterval(() => {
            setSum(sessionStorage.getItem('sumNber'))
            if(sessionStorage.getItem('sumNber') <= 5){
                clearInterval(tiemId)
                setSum(5)
                sessionStorage.removeItem('sumNber');
            }
        }, 200);
    },[])

    useEffect(() => {
        let timer = null
        // 倒计时
        timer = setInterval(() => {
            setCountDown((countDown) => {
                return --countDown
            })
        }, 1000)
        return () => {
            clearInterval(timer)
        }
    }, [])
    useEffect(() => {
        let pathSearch = history.search.substring(1)
        pathSearch = pathSearch.split('=')
        if (pathSearch[0] === 'checked' && pathSearch[1] === 'true') {
            setChecked(pathSearch[1])
        }
    }, [setChecked, history.search])
    // 子组件方法
    const childRef = useRef()
    const loginRef = useRef()
    // const refLogin = useRef()
    // 登录或者支付onClick={() => setModal2(true)}
    const handleFun = () => {
        // setModal3(true)
        // return
        if (!subFlag) {
            console.log('未输入')
            return
        }
        if (!getPhone()) {
            // 登录操作
            let result = loginRef.current.login()
            result.then((res) => {
                if (res !== 0 && res.code === 1) {
                    setPhoneNum((phoneNum = !phoneNum))
                    setUserPhone((userPhone = loginRef.current.phoneNumber))
                    setMember_id(res.data.member_id)
                    setKey(res.data.key)
                    localStorage.setItem('member_id', res.data.member_id)
                    sessionStorage.setItem('member_id', res.data.member_id)
                    // 存储key
                    sessionStorage.setItem('key', res.data.key)
                    localStorage.setItem('key', res.data.key)
                    // 存储手机
                    // setUserPhones(userPhone)
                    // console.log(userPhone);
                    storagUsertUserInfo({
                        name: 'phone',
                        value: userPhone,
                    })
                    localStorage.setItem('phone', userPhone)
                    payPopup()
                    burying()
                    // payed()
                } else {
                    if (res == 'localStorage') {
                        payPopup()
                        // payed()
                    } else {
                        Toast.fail(res.message)
                    }
                }
            })
        } else {
            payPopup()
            // payed()
        }
    }
    const burying = () => {
        addGatherRes('pro', {
            "unionid": "",
            "welcomeMsgInfo": "",
            "eventType": resTp.current,
            "resId": resid.current,
            "str":"693e82f636fb56478e8f259232163eea",
            cookie: localStorage.getItem('collection-cookie'),
            "url": window.location.href
        }).then(res => {
            console.log(' res => : ', res)
            sessionStorage.setItem('resid', res.data)
            resid.current = res.data
            resTp.current="pg"
        })
        // jquery.ajax({ 
        //     url:'https://externalg.caixuetang.cn/promotion-collection/gatherRes/addGatherRes',
        //     type:'post',
        //     dataType:'json',
        //     data: JSON.stringify({
        //         "unionid": "",
        //         "welcomeMsgInfo": "",
        //         "eventType": resTp.current,
        //         "resId": resid.current,
        //         "str":"693e82f636fb56478e8f259232163eea",
        //         "url": window.location.href
        //     }),
        //     contentType: 'application/json',
        //     success(res){
        //       if(res.code === 200){
        //         sessionStorage.setItem('resid', res.data)
        //         resid.current = res.data
        //         resTp.current="pg"
        //       }else{
        //       }
        //     }
        //   })
    }
    // 挽留页弹框
    const leave = () => {
        setModal2(false)
        poprs.onClose()
    }
    // 关闭支付页面弹窗
    const leavepay = () => {
        setModal3(false)
        poprs.onClose()
    }

    // 关闭
    const closePopup = () => {
        setModal2(true)
    }
    // 创建订单
    const payPopup = () => {
        payed()
    }

    // 支付
    const payed = useCallback((num) => {
        let key = sessionStorage.getItem('key') || localStorage.getItem('key')
        getNewKey().then((r)=>{
            if(key !=r.data.data){
                sessionStorage.setItem('key',r.data) 
                localStorage.setItem('key',r.data) 
            }
          })
        let userMember = sessionStorage.getItem('member_id') || localStorage.getItem('member_id')
        goodsauthtwo(userMember).then((res) => {
            // res.code = -1 // 临时
            if (res.code !== 1 && !num) {
                // 支付
                setModal3(true)
                setTimeout(() => {
                    addGatherRes('pro', {
                        resId: sessionStorage.getItem('resid'),
                        str:"",
                        url: window.location.href,
                        eventType: 'ip', 
                        unionid: '',
                        cookie: localStorage.getItem('collection-cookie')
                    }).then(res => {
                        console.log(' res => : ', res)
                    })
                },300)
            }
            if (res.code === 1) {
                let memberId =
                    sessionStorage.getItem('member_id') ||
                    localStorage.getItem('member_id')
                window.location.hash = '#/result?member_id=' + memberId
            }
        })
    }, [])
    const enter = () => {
        setModal2(false)
    }
    useEffect(() => {
        if (getPhone()) {
            payed(1)
        }
    }, [payed])

    // const changeVisible = (val) => {
    //     leave()
    // }

    const changeSubFlag = (val) => {
        setSubFlag(val)
    }

    return (
        <Modal
            className={style.antDia}
            transparent
            visible={poprs.visible}
            onClose={() => closePopup()}
            animationType="slide-up"
            afterClose={() => poprs.afterClose()}
            closable={true}
        >
            <p className={style.title}>
            剩余报名时间
        <span className={style.fontRed}>{`${parseInt(countDown / 60)}: ${countDown % 60
                    }`}</span>
            </p>
            {/* <div className={style.titleNotes}>
                <span>班级剩余{sum}名</span>
                <span className={style.notes}>剩余报名时间</span>
            </div> */}
            <div className={style.Login}>
                <Login
                    Lref={loginRef}
                    checked={checked}
                    phoneNum={phoneNum}
                    changeSubFlag={changeSubFlag}
                    changeShowAgreement={poprs.changeShow}
                />
            </div>
            <div className={style.bottomBnt}>
                <button
                    // disabled={!subFlag} //防抖
                    className={style.payBtn}
                    style={{ backgroundColor: `${!subFlag ? '#dcdcdc' : '#2064CA'}` }}
                    onClick={() => {
                        handleFun()
                    }}
                >
                    立即报名
        </button>
            </div>
            <Detainment
                onClose={() => setModal2(false)}
                visible={modal2}
                leave={() => leave()}
                tiemData={sum}
                enter={enter}
                sku_id={poprs.sku_id}
            />
            <DetainmentPay
                onClose={() => setModal3(false)}
                visible={modal3}
                phoneData={userPhone}
                leavepay={() => leavepay()}
                enter={enter}
                sku_id={poprs.sku_id}
                pri={poprs.pri}
            />
        </Modal>

    )
}
